/**
 * Cookies that the application uses
 */
export class Cookies {
  /**
   * The general language
   */
  static readonly LANG = 'lang';

  /**
   * App version
   */
  static readonly APP_VERSION = 'app_version';

  /** Language cookie stays for 60 days */
  static readonly LANG_EXPIRE_DAYS = 60;

  static readonly CSRF_TOKEN = 'XSRF-TOKEN';

  /**
   * The user's preferred language from their settings
   */
  static readonly USER_LANG = 'u_l';

  /**
   * IP address
   */
  static readonly IP = 'i_p';

  /**
   * Unique user id
   */
  static readonly UUID = 'uuid';

  /**
   * Logged user unique id
   */
  static readonly LOGGED_USER_UUID = 'l_u_uuid';

  /**
   * User's current location
   */
  static readonly USER_CURRENT_LOCATION = 'u_c_l';

  /**
   * Environment information
   */
  static readonly ENVIRONMENT = 'environment';

  /**
   * Last modified timestamp
   */
  static readonly LAST_MODIFIED = 'last_modified';

  /**
   * Authentication token
   */
  static readonly AUTH_TOKEN = 'access_token';

  /**
   * Reference token
   */
  static readonly REF = 'ref';

  static readonly PREVIOUS_ROLE = 'previous_role';

  static readonly USER_THEME = 'user_theme';

  static readonly THEME = 'theme';

  static readonly SEEN_DESKTOP_WARNING = 's_d_w';
}
